import axios from 'axios';
import router from '@/router';
import store from '@/store';
import { apiBaseUrl } from '@/environment/environment';

/**
 * Axios basic configuration
 */
const config = {
  baseURL: apiBaseUrl,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
};

/**
 * Creating the instance of Axios
 */
const httpClient = axios.create(config);

/**
 * Auth interceptors
 */
const authInterceptor = config => {
  config.withCredentials = true;
  if (config.showLoader !== false) {
    store.dispatch('showLoader');
  }
  return config;
};

const loggerInterceptor = config => {
  return config;
};

/** Adding the request interceptors */
httpClient.interceptors.request.use(authInterceptor);
httpClient.interceptors.request.use(loggerInterceptor);

/** Adding the response interceptors */
httpClient.interceptors.response.use(
  response => {
    if (response.config.showLoader !== false) {
      store.dispatch('hideLoader');
    }

    store.dispatch('setNewVersion', response);

    if (response.data.success) {
      return response;
    }

    var fullErrorMessage = response.data.message + ' ' + response.data.data;
    generateErrorToast(fullErrorMessage);

    return response;
  },
  error => {
    if (!error.config || error.config.showLoader !== false) {
      store.dispatch('hideLoader');
    }

    if (!error.response || error.response.status == 401) {
      handleResponse.unAuthorizedUser();
    }

    handleResponse.showError(error.response)

    return error
  }
);

function generateErrorToast(error) {
  if (error.status) {
    if (error.status == 401) {
      handleResponse.unAuthorizedUser();
    } else {
      handleResponse.showErrorToast(error);
    }
  }
}

// ← Replaced new Vue({}) with plain object + $awn from window
const handleResponse = {

  getAwn() {
    // Access $awn from the global app instance
    return window.$awn
  },

  showError(error) {
    var errorData = error.data.errors ? error.data.errors : null
    var errorMessage = ''
    var errorLine = ''

    if (errorData) {
      Object.keys(errorData).forEach(function (key) {
        errorMessage += errorData[key] + '<br />';
      });
    } else {
      errorMessage = '<h5><strong>' + error.data.message + '</strong></h5>'
      if (error.data.file && error.data.line) {
        errorLine = '<br /><small>(' + error.data.file + ' Line:' + error.data.line + ')</small>'
      }
    }

    var finalMessage = errorMessage + '<div>' + error.status + ' ' + error.statusText + errorLine + '</div>'

    this.getAwn().alert(finalMessage, {
      labels: {
        alert: ''
      },
      durations: {
        alert: 10000
      }
    })

    return true
  },

  showErrorToast(error) {
    this.getAwn().alert(error.data.data, {
      labels: {
        alert: '[' + error.status + ']' + error.statusText + ' Error'
      }
    })
  },

  showErrorMessage(error) {
    this.getAwn().alert(error, {
      label: "Error: "
    })
  },

  unAuthorizedUser() {
    store.dispatch('unAuthenticateUser');
    router.push('/login');
    return true;
  }
}

export { httpClient };